import React, { useContext, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {DatasContext} from '../datas/DatasContext';
import {ThemeButton} from './ThemeButton';
import ButtonGroup from '@mui/material/ButtonGroup';
import HoverPopover from './HoverPopover';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Fab from '@mui/material/Fab';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';


export default function Intro() {
    
    const {content} = useContext(DatasContext);
    const { t } = useTranslation();
    return (
        <>
        {(content && content.intro) && 
        <div id="intro" className="block bg-gray-200 text-sm leading-6 text-gray-900 pt-20 pb-16 px-6 min-w-80 w-80 h-svh overflow-hidden">
            {content.intro.title && 
            <h1 className="text-3xl mb-0">
                {t('intro.title')}
            </h1>

            }
            {content.intro.subtitle && <h2 id="introSubtitle" className="text-xl mb-4">
                    {t('intro.subtitle')}
                </h2>}
            {content.intro.content && 
                <>
                <Divider/>
                <div className="mt-4 mb-2">
                {content.intro.contentTitle && <p className="text-md font-bold mb-0">
                    {t('intro.contentTitle')} 
                </p>}
                {content.intro.contentSubtitle && <p className="mb-1">
                    {t('intro.contentSubtitle')} 
                    </p>}
                {content.intro.contentIntro && <div id="introContentIntro" className="*:text-justify" dangerouslySetInnerHTML={{__html:t('intro.contentIntro')}} />}
                </div>
                <IntroDialog/>
                </>
                }
            <Divider/>
            <ButtonGroup variant="text" color="info" aria-label="Basic button group" className="mt-4" sx={{
                '& .MuiButtonGroup-firstButton': {borderRight: "1px solid rgba(0, 0, 0, 0.12)"},
            }}>
                {content.intro.ctas && content.intro.ctas.map(cta => {
                    return (<HoverPopover key={cta.href} title={cta.title} subTitle={cta.href}>
                    <ThemeButton {...cta} color="info">{cta.text}</ThemeButton>
                    </HoverPopover>)
                })}
            </ButtonGroup>
        </div>}
        </>
    )
}

export function IntroDialog() {

    const {content} = useContext(DatasContext);
    const [open, setOpen] = useState(false);
    const modalId = 'modal-intro-dialog';
    const { t } = useTranslation();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="mb-4"> 
        <ThemeButton onClick={handleOpen} color="info" sx={{textDecoration:"underline",padding:0}}>
            {t('readmore')}
        </ThemeButton>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby={'title-'+modalId}
            disableScrollLock={true}
            keepMounted={true}
            hideBackdrop={true}
            fullScreen={true}
            fullWidth={true}>
            <Fab sx={{position:"absolute",top:"8px",right:"8px",height:"36px",width:"36px", boxShadow:"unset"}} size="small" color="default" onClick={handleClose}><CloseIcon/></Fab>
            <Box sx={{maxWidth:"650px",margin:"0 auto"}}>
            <DialogTitle id={'title-'+modalId}>
            {content.intro.title && <p className="text-xl mb-0 mt-4">{t('intro.title')}</p>}
            {content.intro.subtitle && <p className="text-xl mb-2 font-normal">{t('intro.subtitle')}</p>}
            </DialogTitle>
            <DialogContent sx={{
                '&':{textAlign:"justify"},
                '& p':{marginBottom:"1rem"}
                }}>
            {content.intro.content && <div dangerouslySetInnerHTML={{__html: t('intro.content')}} />}
            </DialogContent>
            </Box>
        </Dialog>
        </div>
    )

}